import { type InstitutionInfo } from './institutions'

const SHP_PHONE = '6643 6969' as const
const SHP_SUBMISSION_EMAIL = 'shp.msw@singhealth.com.sg' as const

const SHP_LOGO = '/assets/shp-logo.png' as const

export const SHP_COMMON = {
  appointmentPhone: SHP_PHONE,
  mssPhone: SHP_PHONE,
  openingHours: [
    { days: 'Mon - Fri', times: '8am to 1pm, 2pm to 4.30pm' },
    { days: 'Sat, Sun and PH', times: 'Closed' },
  ],
  mssEmail: SHP_SUBMISSION_EMAIL,
  logo: SHP_LOGO,
  website: 'https://polyclinic.singhealth.com.sg/',
} as const

const SHP_POLYCLINICS: Record<string, InstitutionInfo> = {
  Bedok: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Bedok',
    address:
      'Heartbeat@Bedok 11 Bedok North Street 1 #02-01 / 03-01 Singapore 469662',
    appointmentEmail: 'bedokpolyclinic@singhealth.com.sg',
  },
  'Bukit Merah': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Bukit Merah',
    address: 'Blk 163 Bukit Merah Central #04-3565 (Level 8) Singapore 150163',
    appointmentEmail: 'bukitmerahpolyclinic@singhealth.com.sg',
  },
  Eunos: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Eunos',
    address: '1 Chin Cheng Ave, Singapore 429400',
    appointmentEmail: 'eunospolyclinic@singhealth.com.sg',
  },
  'Marine Parade': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Marine Parade',
    address: 'Blk 80 Marine Parade Central #01-792 Singapore 440080',
    appointmentEmail: 'marineparadepolyclinic@singhealth.com.sg',
  },
  Outram: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Outram',
    address:
      '3 Second Hospital Avenue #02-00 Health Promotion Board Building Singapore 168937',
    appointmentEmail: 'outrampolyclinic@singhealth.com.sg',
  },
  'Pasir Ris': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Pasir Ris',
    address: '6 Pasir Ris Drive 8 #1M-01 Singapore 519466',
    appointmentEmail: 'pasirrispolyclinic@singhealth.com.sg',
  },
  Punggol: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Punggol',
    address: '681 Punggol Drive, #02-01, Oasis Terraces, Singapore 820681',
    appointmentEmail: 'punggolpolyclinic@singhealth.com.sg',
  },
  Sengkang: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Sengkang',
    address: '2 Sengkang Square #01-06 Sengkang Community Hub Singapore 545025',
    appointmentEmail: 'sengkangpolyclinic@singhealth.com.sg',
  },
  Tampines: {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Tampines',
    address: '1 Tampines Street 41, Singapore 529203',
    appointmentEmail: 'tampinespolyclinic@singhealth.com.sg',
  },
  'Tampines North': {
    ...SHP_COMMON,
    fullName: 'SingHealth Polyclinics - Tampines North',
    address: '35 Tampines Street 61, Singapore 528566',
    appointmentEmail: 'tampinesnorthpolyclinic@singhealth.com.sg',
  },
} as const

// No dedicated FC appointment phone/email; patients call the general enquiries hotline
const NHGP_PHONE = '6355 3000' as const
const NHGP_SUBMISSION_EMAIL =
  'nhgp.financial.counselling@nhghealth.com.sg' as const

const NHGP_LOGO = '/assets/nhgp-logo.png' as const

export const NHGP_COMMON = {
  appointmentPhone: NHGP_PHONE,
  mssPhone: NHGP_PHONE,
  openingHours: [
    { days: 'Mon - Fri', times: '8am to 1pm, 2pm to 4.30pm' },
    { days: 'Sat', times: '8am to 12.30pm' },
    { days: 'Sun and PH', times: 'Closed' },
  ],
  appointmentEmail: '',
  mssEmail: NHGP_SUBMISSION_EMAIL,
  logo: NHGP_LOGO,
} as const

const NHGP_POLYCLINICS: Record<string, InstitutionInfo> = {
  'Ang Mo Kio': {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Ang Mo Kio',
    address: '21 Ang Mo Kio Central 2, Singapore 569666',
  },
  Geylang: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Geylang',
    address: '21 Geylang East Central, Singapore 389707',
  },
  Hougang: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Hougang',
    address: '89 Hougang Avenue 4, Singapore 538829',
  },
  Kallang: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Kallang',
    address: '701 Serangoon Road, Singapore 328263',
  },
  Khatib: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Khatib',
    address: '690 Yishun Ring Road, Singapore 769567',
  },
  Sembawang: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Sembawang',
    address: '21 Canberra Link, #01-03, Singapore 756973',
  },
  Serangoon: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Serangoon',
    address: '587 Upper Serangoon Road, Singapore 534564',
  },
  'Toa Payoh': {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Toa Payoh',
    address: '2003 Toa Payoh Lorong 8, Singapore 319260',
  },
  Woodlands: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Woodlands',
    address: '10 Woodlands Street 31, Singapore 738579',
  },
  Yishun: {
    ...NHGP_COMMON,
    fullName: 'NHG Polyclinics - Yishun',
    address: '2 Yishun Avenue 9, Singapore 768898',
  },
} as const

export const POLYCLINICS: Record<string, Record<string, InstitutionInfo>> = {
  SHP: SHP_POLYCLINICS,
  NHGP: NHGP_POLYCLINICS,
} as const

export const getPolyclinic = (institution: string, polyclinic: string) =>
  POLYCLINICS[institution]?.[polyclinic]
